import { SxProps, Theme } from '@mui/material';
import { FC } from 'react';
import {
  StyledStatusContainer,
  StyledStatusIcon,
  StyledStatusText,
  getStatusIconClass,
} from 'src/components/StyledComponents/StyledStatus';

interface StatusProps {
  status: string;
  sx?: SxProps<Theme>;
}

const Status: FC<StatusProps> = ({ status, sx }) => {
  const normalizedStatus = status ? status.toLowerCase() : 'inactive';

  const getStatusType = ():
    | 'active'
    | 'inactive'
    | 'closed'
    | 'suspended'
    | 'new'
    | 'pending'
    | 'pending approval'
    | 'approved'
    | 'rejected'
    | 'payment progress'
    | 'payment pending'
    | 'paid'
    | 'completed'
    | 'payment completed'
    | 'issued'
    | 'realized'
    | 'returned'
    | 'cancelled'
    | 'verified'
    | 'unverified' => {
    switch (normalizedStatus) {
      case 'active':
        return 'active';
      case 'inactive':
        return 'inactive';
      case 'closed':
        return 'closed';
      case 'suspended':
        return 'suspended';
      case 'new':
        return 'new';
      case 'pending':
        return 'pending';
      case 'pending approval':
        return 'pending approval';
      case 'approved':
        return 'approved';
      case 'rejected':
        return 'rejected';
      case 'payment progress':
        return 'payment progress';
      case 'payment pending':
        return 'payment pending';
      case 'paid':
        return 'paid';
      case 'completed':
        return 'completed';
      case 'payment completed':
        return 'payment completed';
      case 'issued':
        return 'issued';
      case 'realized':
        return 'realized';
      case 'returned':
        return 'returned';
      case 'cancelled':
        return 'cancelled';
      case 'verified':
        return 'verified';
      case 'unverified':
        return 'unverified';
      default:
        return 'inactive';
    }
  };

  const statusType = getStatusType();
  const iconClass = getStatusIconClass(normalizedStatus);

  return (
    <StyledStatusContainer statusType={statusType} sx={sx}>
      <StyledStatusIcon
        component="i"
        className={iconClass}
        statusType={statusType}
      />
      <StyledStatusText statusType={statusType}>
        {normalizedStatus || 'inactive'}
      </StyledStatusText>
    </StyledStatusContainer>
  );
};

export default Status;
